<template>
    <div>
        <div class="locations-tabs__wrapper" v-if="!banner_homepage">
            <nav class="locations-tabs">
                <div class="locations-tabs__inner">
                    <ul class="tabs" id="" data-deep-link="true" data-update-history="true" data-tabs="ow5629-tabs" role="tablist">

                        <li class="tabs-title is-active" role="presentation">
                            <a href="/find-care" role="tab" aria-controls="providers-results" aria-selected="true" id="providers-results-label" tabindex="0">

                                <span class="tabs-icon" aria-hidden="true" role="presentation">
                                    <svg width="31" height="27" aria-hidden="true">
                                        <use xlink:href="/assets/images/static/sprite.svg#find-a-doc"></use>
                                    </svg>
                                </span>

                                Find a Doctor
                            </a>
                        </li>
                        <li class="tabs-title " role="presentation">
                            <a href="/locations" role="tab" aria-controls="locations-results" aria-selected="false" id="locations-results-label" tabindex="-1">

                                <span class="tabs-icon" aria-hidden="true" role="presentation">
                                    <svg width="31" height="27" aria-hidden="true">
                                        <use xlink:href="/assets/images/static/sprite.svg#hospital"></use>
                                    </svg>
                                </span>

                                Find a Location
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
        <div class="c-keyboard-search-hero" v-bind:class="{ 'search-hero-homepage' : banner_homepage }">          
            <div class="c-keyboard-search-hero--content">
                <div class="c-keyboard-search-hero--content-wrapper typeahead-container">
                    <h1 v-if="!banner_homepage">Find a Doctor</h1>

                    <div class="c-keyboard-search-hero--input-container">

                            <div class="c-keyboard-search-hero--keyword">
                                <label>
                                    <span><b>Enter a Specialty, Condition, or Doctor Name</b></span>
                                    <div class="input-set">
                                        <input
                                            type="search"
                                            name="keyboard-search-hero" 
                                            id="keyboard-search-hero" 
                                            class="form__input"
                                            data-typeahead-type="keyboard-search-hero"
                                            data-typeahead-min-length="1"
                                            aria-label="Enter a Specialty, Condition, or Doctor Name"
                                            placeholder=""
                                            ref="keywordField"
                                            v-model="search_text"
                                            @keyup="onSearchChange"
                                            @keydown="handleKeydown"
                                            @blur="onFieldLostFocus"
                                            autocomplete="off"
                                            :aria-invalid="showSelectionError ? 'true' : 'false'"
                                            aria-describedby="keyboard-search-hero-error"
                                        >
                                        <svg class="icn-search" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.24857 0.800781H7.50057C9.43557 0.917781 11.2806 1.91678 12.4146 3.61778C13.9716 5.95778 13.8006 9.00878 12.0456 11.1418L15.2046 14.3008L14.3046 15.2008L11.1456 12.0418C10.0926 12.8968 8.78757 13.4008 7.42857 13.4638H7.13157C4.10757 13.4638 1.50657 11.3308 0.921567 8.36978C0.336567 5.40878 1.92057 2.43878 4.71957 1.28678C5.53857 0.944781 6.40257 0.791781 7.24857 0.809781V0.800781ZM7.14057 2.06978C4.71957 2.06978 2.64057 3.77978 2.17257 6.14678C1.70457 8.51378 2.97356 10.8898 5.20556 11.8168C5.79956 12.0598 6.42057 12.1858 7.03257 12.2038H7.26657C8.87757 12.1678 10.4166 11.3578 11.3616 9.95378C12.7026 7.94678 12.4416 5.26478 10.7316 3.55478C9.77757 2.60078 8.49056 2.06978 7.14956 2.06978H7.14057Z" fill="#4D4D4D"/>
                                        </svg>

                                    </div>
                                    <!-- div, not span/p: `label span` and `p` out-specify this class -->
                                    <div
                                        id="keyboard-search-hero-error"
                                        class="c-keyboard-search-hero--error"
                                        role="alert"
                                        v-if="showSelectionError"
                                    >Please select a specialty, condition, or doctor from the suggestions.</div>
                                </label>

                                <div class="typeahead" ref="typeaheadContainer" v-if="searchResults && this.search_text != ''">
                                    <div v-for="(array, key, index) in searchResults">
                                        <h3 :class="{'typeahead__title--first': index === 0, 'typeahead__title': true}">{{ getCategoryFriendly(key) }}</h3>
                                        <ul>
                                            <li v-for="(item, index) in array" :class="{ 'highlighted': search_text === item.name }" :key="index">
                                                <button @mousedown.prevent="onUpdateField(key, item)" :value="item.name" v-html="item.highlight"></button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="c-keyboard-search-hero--distance-and-submit">
                                <DistanceFilter :showDistanceControls="false" :heroSearch="true" />
                                <button @click="onSearchClick" class="keyboard-search-hero--submit">{{ bannerButtonTitle }}</button>
                            </div>

                            <button @click.prevent="openFilters" class="keyboard-search-hero--filter">Sort and Filter <span v-if="!isEmpty(ActiveFilters) && filtersCount(ActiveFilters) != 0">({{ filtersCount(ActiveFilters) }})</span></button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from "vuex";
  import DistanceFilter from "./DistanceFilter.vue";

  export default {
    name: "KeyboardSearchHero",
    data: () => {
      return {
        search_text: "",
        location_text: "",
        originalSearch_text: '',
        selectedItemIndex: -1,
        hasSelection: false,
        selectedValue: null,
        selectedCategory: null,
        showSelectionError: false,
      };
    },
    props: {
    },
    computed: {
        // KeywordCategory intentionally absent - its getter is stale, see onSearchClick
        ...mapGetters(["ActiveFilters", "Keyword", "banner_only", "banner_homepage", "banner_button_title", "search_url", "HasUrlParams", "clearAll", "resultsLoading", "Location", "LocationName"]),
        searchResults() {
            if(this.$store.state.typeahead.SearchResults){
                const entries = Object.entries(this.$store.state.typeahead.SearchResults);
                const filteredEntries = entries.filter(([key, value]) => key !== 'category_names' && value);
                const filteredObject = Object.fromEntries(filteredEntries);
                if((Object.keys(filteredObject).length)){
                    return filteredObject;
                }
            }
            return null;
        },
        categoryNames() {
            if(this.$store.state.typeahead.SearchResults){
                const entries = Object.entries(this.$store.state.typeahead.SearchResults);
                const filteredEntries = entries.filter(([key, value]) => key === 'category_names');
                const filteredObject = Object.fromEntries(filteredEntries);
                return filteredObject;
            }
            return {};
        },
        bannerButtonTitle(){
            return this.banner_button_title || "Search";
        }
    },
    components: {
        DistanceFilter
    },
    methods: {
        ...mapActions(["fetchResults", "updateActiveFilters"]),
        ...mapMutations(["addOrUpdateFilter", "removeFilter"]),
        getKeywordFromUrl() {
            // Rely on the Vuex Store (this.Keyword) which already parsed 'specialties',
            // rather than manually inspecting the raw URL and missing dynamic categories.
            if(this.Keyword){
                this.search_text = this.Keyword;
                this.toggleFilter("Keyword", this.search_text);
            }
        },
        getCategoryFriendly(key) {
            const comp = this;
            let friendly = key;

            if(comp.categoryNames && comp.categoryNames.category_names){
                friendly = comp.categoryNames.category_names[key] || friendly;
            }

            return friendly;
        },
        onSearchChange: _.debounce(function(e) {
            if(e.keyCode !== 38 && e.keyCode !== 40 && e.key !== 'Enter'){
                if (this.search_text.length < 3) return;
                this.originalSearch_text = this.search_text;
                this.$store.dispatch('fetchSearchResults', this.search_text);
            }
        }, 500),
        onUpdateField(key, item){
            const value = item.name;

            // Falls through when the api omits the url, rather than dead-ending
            if(key === 'provider_name' && item.url){
                window.location = item.url;
                return;
            }

            // selectedValue before search_text, or the watcher reads it as typing
            this.selectedCategory = key;
            this.selectedValue = value;
            this.hasSelection = true;
            this.showSelectionError = false;
            this.search_text = value;
            this.selectedItemIndex = -1;
            this.$store.commit("SearchResults", null);
        },
        onFieldLostFocus(){
            this.selectedItemIndex = -1;
            this.$store.commit("SearchResults", null);
        },
        onSearchClick: function() {
            if(!this.hasSelection || !this.search_text){
                this.showSelectionError = true;
                return;
            }
            this.showSelectionError = false;

            // Raw state, not the getter: KeywordCategory isn't declared in the module's
            // initial state, so it never became reactive and the getter is stuck at undefined.
            const category = this.selectedCategory || this.$store.state.results.KeywordCategory || null;

            if(this.banner_only){
                if(this.search_url){
                    // ?Keyword= and ?specialties= return different sets for the same term
                    const param = category || 'Keyword';
                    // encodeURI leaves & and = intact, truncating any term containing them
                    let query = `${param}=${encodeURIComponent(this.search_text)}`;
                    if (this.Location) {
                        query += `&Location=${encodeURIComponent(this.Location)}`;
                        if (this.LocationName) query += `&LocationName=${encodeURIComponent(this.LocationName)}`;
                    }
                    window.location = `${this.search_url}?${query}`;
                }
                return;
            }

            this.$store.commit("Keyword", this.search_text);
            this.$store.commit("KeywordCategory", category);

            // SYNC TO SIDEBAR: Explicitly populate the sidebar store values so it reflects what was picked here
            if (category === 'specialties') {
                this.$store.commit("Specialties", this.search_text);
            } else if (category === 'provider_name') {
                this.$store.commit("ProviderName", this.search_text);
            }

            this.fetchResults();
            this.toggleFilter("Keyword", this.search_text);
        },
        handleKeydown(e){
            if (e.key === 'Enter') {
                e.preventDefault();
                // Enter on a highlighted option is a pick, not a submit
                const highlighted = this.selectedItemIndex > -1 ? this.itemAt(this.selectedItemIndex) : null;
                if (highlighted) {
                    this.onUpdateField(highlighted.key, highlighted.item);
                } else {
                    this.onSearchClick();
                }
                return;
            }

            if (this.searchResults && this.search_text != '') {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.selectedItemIndex = Math.min(this.selectedItemIndex + 1, this.getTotalItems() - 1);
                    this.selectItem(this.selectedItemIndex);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.selectedItemIndex = Math.max(this.selectedItemIndex - 1, -1);
                    this.selectItem(this.selectedItemIndex);
                }
            }
        },
        getTotalItems() {
            let totalItems = 0;
            for (const key in this.searchResults) {
                totalItems += this.searchResults[key].length;
            }
            return totalItems;
        },
        itemAt(index) {
            let currentIndex = 0;
            for (const key in this.searchResults) {
                const categoryItems = this.searchResults[key];
                if (index >= currentIndex && index < currentIndex + categoryItems.length) {
                    return { key, item: categoryItems[index - currentIndex] };
                }
                currentIndex += categoryItems.length;
            }
            return null;
        },
        selectItem(index){
            if (index === -1) {
                this.search_text = this.originalSearch_text;
                return;
            }
            const found = this.itemAt(index);
            if (found) {
                this.search_text = found.item.name;
                this.scrollIntoView();
            }
        },
        revealTypeahead() {
            if (!window.matchMedia('(max-width: 991px)').matches) return;
            this.$nextTick(() => {
                const list = this.$refs.typeaheadContainer;
                const viewport = window.visualViewport;
                const visibleTop = viewport ? viewport.offsetTop : 0;
                const visibleBottom = visibleTop + (viewport ? viewport.height : window.innerHeight);
                if (!list || list.getBoundingClientRect().bottom <= visibleBottom) return;

                const header = document.querySelector('.js-header');
                const headerHeight = header ? header.offsetHeight : 0;
                window.scrollBy(0, this.$refs.keywordField.getBoundingClientRect().top - visibleTop - headerHeight - 10);
                const space = visibleBottom - list.getBoundingClientRect().top - 10;
                if (space < list.offsetHeight) list.style.maxHeight = `${Math.max(space, 150)}px`;
            });
        },
        scrollIntoView() {
            this.$nextTick(() => {
                const container = this.$refs.typeaheadContainer;
                const highlightedItem = container.querySelector('.highlighted');
                if (highlightedItem) {
                highlightedItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            });
        },
        isEmpty(obj){
            if(Object.keys(obj).length === 0){
                return true;
            }
        },
        filtersCount(obj){
            if(obj.hasOwnProperty('Keyword')){
                return Object.keys(obj).length - 1;
            } else {
                return Object.keys(obj).length;
            }
        },
        openFilters(){
            this.$store.commit("mobileFilterActive", true);
        },
        toggleFilter(key, value) {
            if(value){
                this.addOrUpdateFilter({ key, value });
            }
            else{
                this.removeFilter(key);
            }
        }
    },
    mounted(){
        this.getKeywordFromUrl();
    },
    watch: {
        searchResults(results, previous) {
            if (results && !previous) this.revealTypeahead();
        },
        search_text: function(newVal, oldVal) {
            // Nulling selectedValue too stops a hand-retyped term matching and re-validating
            if (newVal !== this.selectedValue) {
                this.hasSelection = false;
                this.selectedValue = null;
                this.selectedCategory = null;
                this.showSelectionError = false;
            }

            // Ensure both null and empty string trigger the clearing event properly
            if ((newVal === '' || newVal === null) && (oldVal !== '' && oldVal !== null)) {
                this.$store.commit("Keyword", null);
                this.$store.commit("KeywordCategory", null);
                this.removeFilter("Keyword");
                if (!this.resultsLoading && !this.$store.state.firstLoad) {
                    this.fetchResults();
                }
            }
        },
        'Keyword': {
            immediate: true,
            handler(keyword) {
                // Url params and sidebar picks are already validated selections
                if (keyword) {
                    this.selectedValue = keyword;
                    this.hasSelection = true;
                }
                // Map strictly both ways to keep the store and input field synced
                this.search_text = keyword;
            },
        },
        'HasUrlParams': function(){
            let comp = this;
            if(comp.HasUrlParams){
                comp.search_text = this.Keyword;
                comp.toggleFilter("Keyword", this.Keyword);
                comp.$store.commit("HasUrlParams", false);
            }
        },
        'kaywordRemoved': {
            immediate: true,
            handler(keywordRemoved) {
                if (keywordRemoved === true) {
                    //Set static values = to the values in the Store
                    this.search_text = null;
                    console.log(this.search_text);
                    this.$store.commit("keywordRemoved", false);
                }
            },
        },
        'clearAll': function(){
            if (this.clearAll === true) {
                this.search_text = '';
            }
        },
    }
  };
</script>